import "./bootstrap";
import { createInertiaApp } from "@inertiajs/svelte";
import * as Sentry from "@sentry/svelte";

if (import.meta.env.VITE_APP_ENV !== "local") {
  Sentry.init({
    dsn: "https://0394a28334a4832fc78f044e775011e7@o4507534170521600.ingest.us.sentry.io/4509005361774592",
    environment: import.meta.env.VITE_APP_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/app02\.uat\.ar\.tylertech\.com\/dfa\/arstar/,
    ],
  });
}

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob(
      [
        "./Pages/**/*.svelte",
        "!./Debug/**",
        "!./Pages/Admin/**",
        "!./Pages/DFA/**",
      ],
      { eager: true }
    );
    return pages[`./Pages/${name}.svelte`];
  },
  setup({ el, App, props }) {
    new App({ target: el, props });
  },
  progress: {
    color: "#dc3545",
    includeCSS: true,
  },
});
